module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/heading_banner_blue-b95765c729d5964bd72f45212cfe4a2b.png";